import { _CreditAccount } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../../theme/Component/BasicPage"
import { BasicTable, MASK_NUMBER } from "../../../../theme/Component/BasicTable"

export const ComiteCredito=()=>{

    const _credit = useDataBean(_CreditAccount);
    const {bean,setBean,lista,setLista,handleChange} = _credit;


    const head = [
        {title:'ID',property:'IDAccountProject',visible:true,mask:MASK_NUMBER},
        {title:'Nombre',property:'Name',visible:true},
        {title:'Descripcion',property:'Description',visible:true}        
    ]

    return(
        <BasicPage titulo="Estudio Comite Credito">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable  head={head} body={lista} rowSet={setBean}></BasicTable>
                </div>
            </div>
        </BasicPage>
    )
}